import VFileInput from './VFileInput';
export { VFileInput };
export default VFileInput;
//# sourceMappingURL=index.js.map